import { WasmGitModule } from '../wasm-git.worker.model';

let authToken: string | null = null;

declare const Module: WasmGitModule;

function overrideHttpConnect() {
  if (!('Module' in self)) {
    return;
  }
  const originHttpConnect = Module.emscriptenhttpconnect;
  Module.emscriptenhttpconnect = function (...args: unknown[]) {
    args.length = 4;

    args[3] = {
      Authorization: `Bearer ${authToken}`,
    };

    return originHttpConnect?.apply(this, args) as number;
  };
}

export function setToken(token: string) {
  if (!authToken) {
    overrideHttpConnect();
  }
  authToken = token;
}
